var $ = require('jQuery');
var Strip = require('../vendor/staaky/strip.pkgd.js');

module.exports = {
    init: function() {
        $.extend(Strip.Skins.strip, {
            onShow: function() {
                var stripWindow = $('.strp-window');

                // Check that the overlay doesn't exist yet
                if (stripWindow.prev().hasClass('strp-overlay')) {
                    return;
                }

                $($('<div />').addClass('strp-overlay')).insertBefore(stripWindow);
            },
            afterHide: function() {
                $('.strp-overlay').remove();
            }
        });
    }
};
